export var LOCATION_CHANGED = 'LOCATION_CHANGED';
